import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { MediaPlaylistDto } from '@/types/dtos/media/media-playlist.dto.ts';
import { patchMediaPlaylistInQueryCache } from '@/state/mutations/media/patch-media-playlist-cache.ts';

export const useDeleteVirtualMediaSequenceImageMutation = () => {
  const queryClient = useQueryClient();
  const { getToken } = useAuth();

  return useMutation({
    mutationFn: async ({ playlistId, slug, order }: { playlistId: string; slug: string; order: number }) => {
      const token = await getToken();
      return deleteVirtualMediaSequenceImage(playlistId, slug, order, token ?? '');
    },
    onSuccess: (updatedPlaylist) => {
      patchMediaPlaylistInQueryCache(queryClient, updatedPlaylist);
    },
  });
};

const deleteVirtualMediaSequenceImage = async (
  playlistId: string,
  slug: string,
  order: number,
  token: string,
): Promise<MediaPlaylistDto> => {
  const url = `${import.meta.env.VITE_API_URL}/media-playlists/${playlistId}/virtual-media/${encodeURIComponent(slug)}/images/${order}`;
  return sendJSONRequest({ url, method: METHOD.DELETE, token });
};
